/**
 * User-permission-check schema, re-exported from the generated Zod unchanged.
 *
 * `userEmail` keeps the generated `.email()` check — unlike a stored
 * `User.email` (which can persist blank), this is the request's own validated
 * input echoed back. See ./README.md.
 */
import { UsersCheckPermissionCreateResponse } from '~/data/generated/zod/users/users.zod';

export const userPermissionCheckSchema = UsersCheckPermissionCreateResponse;
